var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnclosedRedCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443",
    transform: "translate(-872 -800)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quit",
    transform: "translate(872 800)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,1.5A10.5,10.5,0,1,0,22.5,12,10.512,10.512,0,0,0,12,1.5Zm0,0",
    fill: "#fa1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M7.032,15.206a.75.75,0,0,1-.53-1.281L13.927,6.5a.75.75,0,0,1,1.061,1.061L7.563,14.986a.751.751,0,0,1-.531.22Zm0,0",
    transform: "translate(1.256 1.256)",
    fill: "#fa1616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M14.456,15.206a.744.744,0,0,1-.53-.22L6.5,7.562A.75.75,0,0,1,7.562,6.5l7.425,7.425a.749.749,0,0,1-.531,1.28Zm0,0",
    transform: "translate(1.256 1.256)",
    fill: "#fa1616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnclosedRedCloseIcon);
export default __webpack_public_path__ + "static/media/enclosed-red-close-icon.83b97f5d3d68e414089af7b14203907e.svg";
export { ForwardRef as ReactComponent };